import { NewsItem } from '@/app/libs/match/types'
import { MatchCard, MatchCardSmall } from './match-cards'

export default function NewsList({ news }: { news: NewsItem[] }) {
  return (
    <>
      <p className="text-lg font-bold text-textOffWhite mb-3">Latest News</p>
      {news[0] ? <MatchCard data={news[0]} /> : null}
      {news?.length > 1 ? (
        <div className="grid grid-cols-2 gap-y-6 gap-x-4 mt-6">
          {news?.slice(1, 5).map(data => {
            return (
              <div className="md:col-span-1 col-span-2" key={data?._id}>
                <MatchCardSmall data={data} />
              </div>
            )
          })}
        </div>
      ) : null}
    </>
  )
}
